import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import _ from 'lodash'

import { fanalToggleGraphTable, fanalChangeSelectedYear } from './actions'

function mapStateToProps(state, hocProps) {
    const id = _.get(hocProps, 'id', null)
    const module = _.get(hocProps, 'module', null)

    return {
        showDataTable: state.getIn([
            'ui',
            'workspace',
            module,
            id,
            'blocks',
            'fanal',
            'customData',
            'radarGraph',
            'showDataTable',
        ]),
        selectedYear: state.getIn([
            'ui',
            'workspace',
            module,
            id,
            'blocks',
            'fanal',
            'customData',
            'radarGraph',
            'selectedYear',
        ]),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            fanalToggleGraphTable,
            fanalChangeSelectedYear,
        },
        dispatch
    )
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
